import React, { useEffect, useState } from 'react'
import { MilestoneCollaborationsFilters, MilestoneCollaborationSortOptions, MilestoneCollaborationStatus, MilestoneCollaborationStatusLabel, MilestoneCollaborationSortOptionLabel } from 'types/collaboration';

interface MilestoneCollaborationFiltersProps {
    defaultFilters: MilestoneCollaborationsFilters,
    onApply: (updatedFilters: MilestoneCollaborationsFilters) => void
}

export const defaultFiltersValue = {
    page: 1,
    sort: MilestoneCollaborationSortOptions.LAST_ACTIVITY_AT,
    status: MilestoneCollaborationStatus.ONGOING
}

const Filters: React.FC<MilestoneCollaborationFiltersProps> = (
    {
        defaultFilters,
        onApply
    }) => {


    const [filters, setFilters] = useState<MilestoneCollaborationsFilters>(defaultFilters);

    useEffect(() => {
        setFilters(defaultFilters);
    }, [defaultFilters])

    const handleFilterChange = (key: string, value: MilestoneCollaborationSortOptions | MilestoneCollaborationStatus | string) => {
        setFilters({ ...filters, [key]: value });
    }

    return (
        <div className='filters-card'>
            <div className="p-4 pb-0">
                <div className="d-flex flex-column">
                    <span className="filter-title">Status</span>
                    <div className="d-flex mt-2 gap-2 justify-content-start align-items-center flex-wrap">
                        {
                            Object.values(MilestoneCollaborationStatus).map((filterVal, i) => <span key={i} onClick={() => handleFilterChange('status', filterVal)} className={`filters-badge ${filters.status === filterVal && 'active'}`}>{MilestoneCollaborationStatusLabel[filterVal]}</span>)
                        }
                    </div>
                </div>
                <div className="d-flex flex-column mt-4">
                    <span className="filter-title">Assigned to me?</span>
                    <div className="d-flex mt-3 gap-2 justify-content-start align-items-center flex-wrap">
                        {
                            ['y', 'n'].map((filterVal, i) => <span key={i} onClick={() => handleFilterChange('assigned_self', filterVal)} className={`filters-badge ${filters.assigned_self === filterVal && 'active'}`}>{filterVal === 'y' ? 'Yes' : 'No'}</span>)
                        }
                    </div>
                </div>
                <div className="d-flex flex-column mt-4">
                    <span className="filter-title">Sort By</span>
                    <div className="d-flex mt-3 gap-2 justify-content-start align-items-center flex-wrap">
                        {
                            Object.values(MilestoneCollaborationSortOptions).map((filterVal, i) => <span key={i} onClick={() => handleFilterChange('sort', filterVal)} className={`filters-badge ${filters.sort === filterVal && 'active'}`}>{MilestoneCollaborationSortOptionLabel[filterVal]}</span>)
                        }
                    </div>
                </div>
            </div>
            <div className="divider mt-4"></div>
            <div className="d-flex justify-content-end align-items-center gap-3 px-4 py-3">
                <button className="theme-btn btn-primary-outlined" onClick={() => onApply({ ...defaultFiltersValue})}>Reset</button>
                <button className='theme-btn btn-primary' onClick={() => onApply(filters)}>Apply</button>
            </div>
        </div>
    )
}

export default Filters